/* eslint-disable react/prop-types */
import { Checkbox, FormControlLabel, Select } from "@mui/material";
import Grid from "@mui/material/Grid";
import MenuItem from "@mui/material/MenuItem";
import SoftBox from "../../components/SoftBox";
import SoftInput from "../../components/SoftInput";
import SoftTypography from "../../components/SoftTypography";
import SoftButton from "components/SoftButton";

export default function TableHeadItems({ filterInfo, handleFilterChange, onFilterClick }) {

    return (
        <Grid container gap={2} mb={2}>
            <Grid item xs={12} md={6} lg={2}>
                <SoftBox mb={1} ml={0.5}>
                    <SoftTypography component="label" variant="caption" fontWeight="bold">
                        نام
                    </SoftTypography>
                </SoftBox>
                <SoftInput value={filterInfo?.name} name="name" onChange={handleFilterChange}
                    type="text" />
            </Grid>
            <Grid item xs={12} md={6} lg={2}>
                <SoftBox mb={1} ml={0.5}>
                    <SoftTypography component="label" variant="caption" fontWeight="bold">
                        نوع
                    </SoftTypography>
                </SoftBox>
                <Select name="type" value={filterInfo?.type} onChange={handleFilterChange}>
                    <MenuItem value="all">همه</MenuItem>
                    <MenuItem value="1">MANUAL</MenuItem>
                    <MenuItem value="2">SMART_LOW</MenuItem>
                    <MenuItem value="3">SMART_MEDIUM</MenuItem>
                    <MenuItem value="4">SMART_HIGH</MenuItem>
                    <MenuItem value="5">SANDOGH</MenuItem>
                </Select>
            </Grid>
              <Grid item xs={12} md={6} pt={5} pl={3} lg={3}>
                <section style={{ display: "flex", flexDirection: "row", columnGap: 30 }}>
                    <FormControlLabel control={<Checkbox defaultChecked={true} checked={filterInfo?.all} name="all" onChange={handleFilterChange}
                    />} label={<p style={{fontSize:12}}>همه</p>} />
                    <FormControlLabel control={<Checkbox checked={filterInfo?.isLock} name="isLock" onChange={handleFilterChange}
                    />} label={<p style={{fontSize:12}}>قفل</p>} />
                </section>
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
                <SoftButton onClick={onFilterClick} size="small" style={{ marginTop: 40, width: 100 }} variant="gradient" color="info">
                    فیلتر
                </SoftButton>
            </Grid>
        </Grid>
    )
}
